import { graphql } from 'gatsby';

import {
  StyledContainer,
  StyledHeading,
  StyledDescription,
  StyledIcon,
} from './CTACardContent.styles';
import Link from '@/components/Link/Link';

const CTACardContent = ({ ctaCardContentElements: elements }: Queries.CTA_CARD_CONTENTFragment) => {
  const { title, description, cta, icon } = elements;

  return (
    <StyledContainer>
      {icon?.value && <StyledIcon {...icon.value} width={32} height={32} />}
      <StyledHeading>{title.value}</StyledHeading>
      {description?.value && <StyledDescription>{description.value}</StyledDescription>}
      <Link {...cta.value} variant="secondary" />
    </StyledContainer>
  );
};

export default CTACardContent;

export const fragment = graphql`
  fragment CTA_CARD_CONTENT on kontent_item_cta_card_content {
    __typename
    ctaCardContentElements: elements {
      title {
        value
      }
      description {
        value
      }
      icon {
        value {
          url
        }
      }
      cta {
        value {
          system {
            id
          }
          ...LINK
        }
      }
    }
  }
`;
